import styled from '@emotion/styled'

export const PrItemFormContent = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
})

export const FieldRow = styled.div({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  flexWrap: 'wrap',
})

export const FieldSection = styled.div({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',

  'span.title': {
    fontSize: '1.15rem',
    fontWeight: 'bold',
    width: '100%',
    paddingBottom: '5px',
    marginBottom: '5px',
  },
})